import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings.js'
import { noop } from 'rxjs'
import {
  PhaseCircle,
  PhaseCircleBackground,
  PhaseCircleOutline,
  PhaseCirclePath,
  PhaseLabel,
} from './LifeCylceButtons.style'

const ObsoleteButton = ({
  isSelected,
  isSelectable,
  withLabel,
  labelTransform,
  transformX,
  transformY,
  onClick = () => noop,
}) => (
  <>
    <PhaseCircle
      isSelected={isSelected}
      isSelectable={isSelectable}
      onClick={isSelectable ? onClick : noop}
      transform={`translate(${transformX} ${transformY})`}
    >
      <PhaseCircleBackground
        cx="13"
        cy="12.966"
        r="12.5"
        strokeLinejoin="square"
      />
      <PhaseCircleOutline
        isSelected={isSelected}
        isSelectable={isSelectable}
        cx="13"
        cy="12.966"
        r="15"
        strokeWidth="1"
      />
      <PhaseCirclePath
        isSelected={isSelected}
        isSelectable={isSelectable}
        strokeWidth="0.1"
        d="M10.908 17.19l1.898-1.896 1.897 1.896.825-.824-1.898-1.896 1.898-1.896-.825-.824-1.897 1.896-1.898-1.896-.825.824 1.898 1.896-1.898 1.896.825.824zM18.444 6.5h-.777V5H16.11v1.5H9.89V5H8.333v1.5h-.777c-.864 0-1.548.675-1.548 1.5L6 18.5c0 .825.692 1.5 1.556 1.5h10.888C19.3 20 20 19.325 20 18.5V8c0-.825-.7-1.5-1.556-1.5zm0 12H7.556v-8.25h10.888v8.25z"
      />
    </PhaseCircle>
    {withLabel && (
      <PhaseLabel
        isSelected={isSelected}
        isSelectable={isSelectable}
        fontFamily="ArialMT, Arial"
        fontSize="12"
        transform={labelTransform}
      >
        <tspan x="155.161" y="43">
          {strings.obsolete}
        </tspan>
      </PhaseLabel>
    )}
  </>
)

ObsoleteButton.defaultProps = {
  withLabel: true,
  labelTransform: 'translate(0 4)',
}

ObsoleteButton.propTypes = {
  isSelected: PropTypes.bool,
  isSelectable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  withLabel: PropTypes.bool,
  transformX: PropTypes.number,
  transformY: PropTypes.number,
  labelTransform: PropTypes.string,
  onClick: PropTypes.func,
}

export default ObsoleteButton
